import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "@hooks/useAppTheme";
import { DialogWrapper, MarkdownRenderer } from "@memorang/ui";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { Button, Dialog } from "react-native-paper";

export const ModuleSummaryDialog = ({
	visible,
	text,
	handleClose,
}: {
	visible: boolean;
	text: string;
	handleClose: () => void;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			minHeight="60%"
			width="100%"
			style={{ backgroundColor: theme.colors.surface }}
		>
			<Dialog.Icon
				icon={(props) => (
					<Icon
						{...props}
						name="book-open-variant"
						size={24}
						accessibilityLabel={t("report.proethica.summary.title")}
						color={theme.colors.primary}
					/>
				)}
			/>
			<Dialog.Title
				style={{
					textAlign: "center",
					marginBottom: 0,
				}}
			>
				{t("report.proethica.summary.title")}
			</Dialog.Title>
			<Dialog.ScrollArea
				style={{
					paddingHorizontal: 0,
				}}
			>
				<ScrollView
					contentContainerStyle={{
						paddingBottom: 24,
						paddingHorizontal: 24,
						paddingTop: 8,
					}}
				>
					<MarkdownRenderer
						variant="explanation"
						text={text}
						paragraphMarginVertical={6}
					/>
				</ScrollView>
			</Dialog.ScrollArea>
			<Dialog.Actions>
				<Button onPress={handleClose}>
					{t("report.proethica.summary.close")}
				</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};
